import Axios from "axios";

class ApiConnector {
  connector;
  constructor() {
    this.connector = Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    this.connectorFormData = Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    this.connector.interceptors.response.use(
      function (response) { return response; },
      function (error) {
        return error.response.data
      }
    );
    this.connectorFormData.interceptors.response.use(
      function (response) { return response; },
      function (error) {
        return error.response.data
      }
    );
  }
  setAuthHeaders(token) {
    this.connector.defaults.headers.common['authorization'] = `Bearer ${token}`;
    this.connectorFormData.defaults.headers.common['authorization'] = `Bearer ${token}`;
  }
  clearAuthHeaders() {
    this.connector.defaults.headers.common["authorization"];
    this.connectorFormData.defaults.headers.common["authorization"];
  }
}

export default new ApiConnector();
